import React from "react";

const DescriptionStudentHealthCheckup = () => {
  return (
    <div className="studentcheckup-container">
      <div className="studentcheckup-hero">
        
        <h1 className="studentcheckup-title">Student 
          <span className="pinkhighlig"> Health Checkup Plans</span>
        </h1>
      </div>

      <div className="studentcheckup-content">
        <p>Want to organize a student health checkup camp at your school, college, or institute?</p>

        <p>
          With <strong>Dr Planete</strong>, you can post a request and connect with doctors, dentists, and hospitals who are part of our platform.
        </p>

        <p><strong>Student health checkups help in:</strong></p>
        
          <li>Early detection of health problems</li>
          <li>Tracking growth and development</li>
          <li>Promoting hygiene and good habits</li>
          <li>Keeping students fit and healthy</li>
        

        <hr></hr>
        <p><strong>How It Works:</strong></p>
        
          <p>Post your request for a student health checkup on <strong>Dr Planete</strong>.</p>
          <p>Doctors, dentists, and hospitals on our platform will be notified.</p>
          <p>Interested members will contact you directly if they are available.</p>
        
      </div>
    </div>
  );
};

export default DescriptionStudentHealthCheckup;

// CSS styles (in the same file)
const style = document.createElement("style");
style.innerHTML = `
  .studentcheckup-container {
    margin: 0 auto;
    width: 100%;
    font-family: 'Poppins', sans-serif;
  }

  .studentcheckup-hero {
    background: black;
    text-align: center;
    padding: 2rem 1rem;
    border-radius: 0px;
    margin-bottom: 2rem;
  }

  .studentcheckup-subtitle {
    color: black;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .studentcheckup-title {
    font-size: 50px;
    color: white;
    font-weight: 700;
  }

  .pinkhighlig {
    color: #FF4081;
  }

  .studentcheckup-content {
    font-size: 18px;
    line-height: 1.6;
    color: #333;
    padding: 0 1rem;
  }

  .studentcheckup-content ul,
  .studentcheckup-content ol {
    margin-left: 1.5rem;
    padding-left: 0.5rem;
  }

  .studentcheckup-content li {
    margin-bottom: 0.5rem;
  }

  @media (max-width: 768px) {
    .studentcheckup-title {
      font-size: 36px;
    }

    .studentcheckup-subtitle {
      font-size: 20px;
    }

    .studentcheckup-content {
      font-size: 19px;
    }
  }
`;
document.head.appendChild(style);
